import React from "react";
import { JobOrder } from "../../interfaces/job.interface";
import { getContainerStatsFromJobOrder } from "../../utils/general";
import "./JobCompletionStatus.scss";

interface JobCompletionStatusProps {
  job: JobOrder;
}

const JobCompletionStatus: React.FC<JobCompletionStatusProps> = ({ job }) => {
  const containerStats = getContainerStatsFromJobOrder(job);

  return (
    <div className="job-completion-status">
      <div className="flex justify-between items-center">
        {/* <span className="total_job_status_percentage">
          {Math.round(containerStats.totalJobStatusPercentage)}%
        </span> */}
        <span className="percentage">
          <span className="total_dropped_containers">
            {containerStats.totalDroppedContainers}{" "}
          </span>
          <span className="total_containers">
            / {containerStats.totalContainer} dropped
          </span>
        </span>
      </div>
      <div className="w-full h-3 job_progress_cover">
        <div
          className="h-3 job_progress"
          style={{ width: `${containerStats.totalJobStatusPercentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default JobCompletionStatus;
